import React from "react";
import Section1 from "../components/Allcontent/Section1";
import data from '../json/Careerpage/CareerpageNew.json'
import Openings from "../components/Careerpage/Openings";
import SEO from "../components/SEO";

const careersSchema = {
  "@context": "https://schema.org",
  "@type": "ItemPage",
  "name": "Careers at Transforma | Job Openings",
  "provider": {
    "@type": "Organization",
    "name": "Transforma Pvt Ltd",
    "url": "https://www.transforma.in/company/career"
  },
  "description": "Explore career opportunities at Transforma. Join our team to build your skills and shape a successful career. Current openings include Template Developer InDesign, PHP / Perl Developer, Trainee Production, and HR Generalist.",
  "keywords": "careers at transforma, transforma job openings, indesign template developer jobs, php perl developer openings, production trainee freshers, hr generalist jobs, publishing industry careers"
};

const Career = () => {
  return (
    <>
    <SEO
        title="Careers at Transforma | Explore Job Opportunities & Openings"
        description="Join Transforma to accelerate your professional growth. Explore current job openings including InDesign Template Developer, PHP / Perl Developer, Production Trainee, and HR Generalist roles."
        keywords="careers at transforma, transforma job openings, indesign template developer jobs, php perl developer hiring, production trainee jobs for freshers, hr generalist jobs, publishing industry recruitment, jobs in india"
        canonical="https://www.transforma.in/company/career"
        schema={careersSchema}
      />
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      <Section1 data={data}/>
      <Openings data={data}/>
    </div>
    </>
  );
};

export default Career;
